import Vue from 'vue';
import Vuetify from 'vuetify/lib';
import i18n from './vue-i18n';

Vue.use(Vuetify);

export default new Vuetify({
  lang: {
    t: (key, ...params) => i18n.t(key, params),
  },
  icons: {
    iconfont: 'mdiSvg',
  },
});

Vue.mixin({
  methods: {
    $translate: function (key) {
      return this.$t(`$vuetify.${key}`);
    },
  },
});
